import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "./Header.css";

import styled from "@emotion/styled";
import { BebopWhiteIcon } from "components/Icons";
import { useIsMobile } from "hooks/useDeviceType";
import { withIsVisible } from "utils/reactUtils";
import { ReactComponent as MobileLogo } from "../../img/mobile-logo.svg";
import { Navbar } from "./Navbar/Navbar";

interface HeaderProps {
  setIsSideNavOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Header = withIsVisible(({ setIsSideNavOpen }: HeaderProps) => {
  const isMobile = useIsMobile();
  const [isSticky, setIsSticky] = useState<boolean>(false);

  // Sticky Menu Area
  useEffect(() => {
    window.addEventListener("scroll", handleStickyHeader);
    return () => {
      window.removeEventListener("scroll", handleStickyHeader);
    };
  });

  /* Method that will fix header after a specific scrollable */
  const handleStickyHeader = () => {
    const scrollTop = window.scrollY;
    if (scrollTop <= 68) {
      setIsSticky(false);
    } else {
      setIsSticky(true);
    }
  };

  return (
    // Header bg color temporarily changed to match Intro's video bg color on non-mobile devices
    // Video bg color currently can't be fixed due to video generator being wonky
    <HeaderContainer isMobile={isMobile} isSticky={isSticky}>
      <div className="row">
        <div className="col-12">
          <nav className="navbar navbar-expand-bebop navbar-light py-0">
            <Link to="/" className="navbar-brand logotext">
              <div className="d-md-block d-none">
                <BebopWhiteIcon />
              </div>
              <div className="d-block d-md-none">
                <MobileLogo />
              </div>
            </Link>
            <div className="d-flex align-items-center">
              <Navbar setIsSideNavOpen={setIsSideNavOpen} />
            </div>
          </nav>
        </div>
      </div>
    </HeaderContainer>
  );
});

const HeaderContainer = styled.div<{ isSticky: boolean; isMobile: boolean }>`
  background-color: ${props => (props.isMobile && !props.isSticky ? "inherit" : "#000000")};
  position: ${props => (props.isSticky ? "fixed" : "relative")};
  width: ${props => (props.isSticky ? "84.5%" : "100%")};
  padding: ${props => (props.isSticky ? "16px 43px" : "16px 10% 0")};
  left: ${props => (props.isSticky ? "50%" : "0")};
  top: 0;
  z-index: 2;

  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.5), 0px 1px 15px 0px rgba(0, 0, 0, 0.25);
  border-radius: 18px;
  margin-top: ${props => (props.isSticky ? "30px" : "0")};
  transform: ${props => (props.isSticky ? "translateX(-50%) !important;" : "none")};
`;
